/*    
@licstart  The following is the entire license notice for the 
JavaScript code in this page.

Copyright (C) 2016  Joseph Safwat Khella

The JavaScript code in this page is free software: you can
redistribute it and/or modify it under the terms of the GNU
General Public License (GNU GPL) as published by the Free Software
Foundation, either version 3 of the License, or (at your option)
any later version.  The code is distributed WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS
FOR A PARTICULAR PURPOSE.  See the GNU GPL for more details.

As additional permission under GNU GPL version 3 section 7, you
may distribute non-source (e.g., minimized or compacted) forms of
that code without the copy of the GNU GPL normally required by
section 4, provided you include this license notice and a URL
through which recipients can access the Corresponding Source.   


@licend  The above is the entire license notice
for the JavaScript code in this page.
*/

var dropDownOptions = {
    title : "Dropdown",
    data : [],
    closedArrow : '<i class="fa fa-caret-right" aria-hidden="true"></i>',
    openedArrow : '<i class="fa fa-caret-down" aria-hidden="true"></i>',
    maxHeight : 300,
    multiSelect : false,
    selectChildren : false,
    addChildren: false,
    clickHandler : function(target){},
    expandHandler : function(target,expanded){},
    checkHandler : function(target,checked){},
    rtl: false,
};


var globalTreeIdCounter=0;
(function($) {

    //data inits from options
    $.fn.DropDownTree = function(options){
    //helpers
    function RenderData(data, element,searchText){
    	console.log("searchText==========",searchText)
        for(var i = 0 ; i< data.length ; i++){
            globalTreeIdCounter++;
            var dataAttrs = "";
            if(typeof data[i].dataAttrs != "undefined" && data[i].dataAttrs != null){
                for(var d = 0 ; d<data[i].dataAttrs.length ; d++){
                    dataAttrs += " data-"+data[i].dataAttrs[d].title+"='"+data[i].dataAttrs[d].data+"' ";
                }
            }
            if(!element.is("li")){
            	var val = " style='margin-left: -30%'";
                if(data[i].data == null && typeof data[i].data == "undefined")
                	element.append('<li class="textTransform" id="TreeElement'+globalTreeIdCounter+'"'+dataAttrs+''+val+'>'+(options.multiSelect?'<i class="fa fa-square-o select-box" aria-hidden="true"></i>':'')+'<a style="text-transform:capitalize">'+data[i].title+'</a></li>');
                else
                	element.append('<li class="textTransform" id="TreeElement'+globalTreeIdCounter+'"'+dataAttrs+'>'+(options.multiSelect?'<i class="fa fa-square-o select-box" aria-hidden="true"></i>':'')+'<a style="text-transform:capitalize">'+data[i].title+'</a></li>');
               
                if(data[i].data != null && typeof data[i].data !="undefined"){
                	var val1 = "";
                	 if(data[i].displayName == null && data[i].title == "All")
                		val1 = "style='display:none;margin-left: -3%'";
                	 else if(data[i].displayName == null && searchText == "")
                		val1 = "style='display:none;margin-left: -13%'";
                	 else 
                		 val1 = "style='display:none;'"; 
                    $("#TreeElement"+globalTreeIdCounter).append("<ul "+val1+"></ul>");
                    $("#TreeElement"+globalTreeIdCounter).find("a").first().prepend('<span class="arrow">'+options.closedArrow+'</span>');
                    RenderData(data[i].data, $("#TreeElement"+globalTreeIdCounter).find("ul").first(),searchText);
                 }else if(options.addChildren){
                    $("#TreeElement"+globalTreeIdCounter).find("a").first().prepend('<span class="arrow">'+options.closedArrow+'</span>');
                }
            }
            else{
                element.find("ul").append('<li class="textTransform" id="TreeElement'+globalTreeIdCounter+'"'+dataAttrs+'>'+(options.multiSelect?'<i class="fa fa-square-o select-box" aria-hidden="true"></i>':'')+'<a style="text-transform:capitalize">'+data[i].title+'</a></li>');
                if(data[i].data != null && typeof data[i].data !="undefined"){
                    $("#TreeElement"+globalTreeIdCounter).append("<ul style='display:none'></ul>");
                    $("#TreeElement"+globalTreeIdCounter).find("a").first().prepend('<span class="arrow">'+options.closedArrow+'</span>');
                    RenderData(data[i].data, $("#TreeElement"+globalTreeIdCounter).find("ul").first());
                }else if(options.addChildren){
                    $("#TreeElement"+globalTreeIdCounter).find("a").first().prepend('<span class="arrow">'+options.closedArrow+'</span>');
                }
            }
        }
    }

    options = $.extend({}, dropDownOptions, options, {element:this});


    //protos inits
    $(options.element).init.prototype.clickedElement = null;

	var tree = $(options.element);

    //handlers binders
    //element click handler
    $(options.element).on("click","li",function(e){
    	tree.init.prototype.clickedElement = $(this);
    	options.clickHandler(tree.clickedElement, e);
        e.stopPropagation();
    });

    //arrow click handler close/open
    $(options.element).on("click",".arrow",function(e){
        e.stopPropagation();
        $(this).empty();
        var expanded;
        if($(this).parents("li").first().find("ul").first().is(":visible")){
            expanded = false;
            $(this).prepend(options.closedArrow);
            $(this).parents("li").first().find("ul").first().hide();
        }else{
            expanded = true;
            $(this).prepend(options.openedArrow);
            $(this).parents("li").first().find("ul").first().show();
        }
        options.expandHandler($(this).parents("li").first(), e, expanded);
    });

  //Get the valyue from the text and perform fltering 
    $(options.element).on("keyup","#searchTextbox",function(e){
        e.stopPropagation();
        console.log(options.data)
        let elements = document.getElementById("parentElement").querySelectorAll('ul > li');
            elements.forEach(n => n.remove())
        var searchText = e.currentTarget.value;
            
            console.log(searchText)
        if(searchText == "" || searchText == undefined){
            RenderData(options.data,$(options.element).find("ul").first(),"");
        }else{
        	var dropDownVal = _.cloneDeep(options.data);
            var resultArr = filterConcept(searchText,dropDownVal);
            RenderData(resultArr,$(options.element).find("ul").first(),searchText);
        }
        
    });
    
  //For filtering purpose
    function filterConcept(search,array){
    	var resultArray = [];
        var resultArray2 = [];
        array.forEach((obj1,index1)=>{
          if(!obj1.hasOwnProperty("data") && obj1['title'].toLowerCase().indexOf(search.toLowerCase()) != -1){
              resultArray.push(obj1);
          }else if(obj1.hasOwnProperty("data")){
              obj1['data'].forEach((obj2,index2)=>{
                  if(!obj2.hasOwnProperty("data") && obj2['title'].toLowerCase().indexOf(search.toLowerCase()) != -1){
                       resultArray.push(obj2);
                  }else if(obj2.hasOwnProperty("data")){
                          var resultArray1 = [];
                          var resultArray1a = [];
                          obj2['data'].forEach((obj3,index3)=>{
                              if(!obj3.hasOwnProperty("data") && obj3['title'].toLowerCase().indexOf(search.toLowerCase()) != -1){
                                  resultArray1.push(obj3);
                               }else if(obj3.hasOwnProperty("data")){
                                  var resultArray2 = [];
                                 obj3['data'].forEach((obj4,index4)=>{
                                   if(!obj4.hasOwnProperty("data") && obj4['title'].toLowerCase().indexOf(search.toLowerCase()) != -1){
                                       resultArray2.push(obj4);
                                   }else if(obj4.hasOwnProperty("data")){
                                        obj4['data'].forEach((obj5,index5)=>{
                                            if(!obj5.hasOwnProperty("data") && obj5['title'].toLowerCase().indexOf(search.toLowerCase()) != -1){
                                                resultArray3.push(obj5);
                                            }else if(obj5.hasOwnProperty("data")){
                                                obj5['data'].forEach((obj6,index5)=>{
                                                  console.log(obj6)
                                                });
      
                                            }
                                        });  
                                   }
                                  if(obj3.hasOwnProperty("data") && obj3['data'].length == index4+1 && resultArray2.length > 0){
                                     obj3['data'].length = 0;
                                     obj3['data'] = obj3['data'].concat(resultArray2);
                                    obj3['title1']=obj2['title'];
                                    resultArray1a.push(obj3)
                                   }
                                 }); 
                               }
                                if(obj2.hasOwnProperty("data") &&obj2['data'].length == index3+1 && resultArray1.length > 0){
                                 delete obj2['data'];
                                 obj2["data"]=resultArray1
                                 resultArray.push(obj2);
                               }else if(obj2.hasOwnProperty("data") && obj2['data'].length == index3+1 && resultArray1a.length > 0){
                                 delete obj2['data'];
                                 obj2["data"]=resultArray1a;
                                 obj2['title'] = resultArray1a[0]['title1'];
                                 resultArray1a = [];
                                 resultArray.push(obj2);
                               }
                          });
                  }
              });
          }
        });
        
        
        return resultArray
        
    }

    //select box click handler
    $(options.element).on("click",".select-box",function(e){
        e.stopPropagation();
        var checked;
        if($(this).hasClass("fa-square-o")){
            //will select
            checked=true;
            $(this).removeClass("fa-square-o");
            $(this).addClass("fa-check-square-o");
            if(options.selectChildren){
                $(this).parents("li").first().find(".select-box").removeClass("fa-square-o");
                $(this).parents("li").first().find(".select-box").addClass("fa-check-square-o");
            }
        }else{
            //will unselect
            checked=false;
            $(this).addClass("fa-square-o");
            $(this).removeClass("fa-check-square-o");
            if(options.selectChildren){
                $(this).parents("li").first().find(".select-box").addClass("fa-square-o");
                $(this).parents("li").first().find(".select-box").removeClass("fa-check-square-o");
                $(this).parents("li").each(function(){
                    $(this).find(".select-box").first().removeClass("fa-check-square-o");
                    $(this).find(".select-box").first().addClass("fa-square-o");
                });
            }
        }
        options.checkHandler($(this).parents("li").first(), e, checked);
    });

    if(options.rtl){
        $(options.element).addClass("rtl-dropdown-tree");
        if(options.closedArrow.indexOf("fa-caret-right")>-1){
            options.closedArrow = options.closedArrow.replace("fa-caret-right","fa-caret-left");
        } 
    }
    $(options.element).append('<button id="dropdownButton" class="form-control_n" style="width:100%; text-align:left; padding: 3px 5px; margin-top:1px; font-size:14px; line-height:1.42857143; text-transform: capitalize !important;" class="dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><span class="dropdowntree-name" style="text-transform:capitalize !important;">'+options.title+'</span><span class="caret"></span></button>');
    $(options.element).append('<ul style="max-height: '+options.maxHeight+'px; text-transform: capitalize !important;" class="dropdown-menu newScroll widDrop" aria-labelledby="dropdownMenu1" id="parentElement"><input class="form-control dropdown-textbox-customize" type="text" placeholder="Search" style="margin:2px !important;width: 98%;" id="searchTextbox"></ul>');
//    $(options.element).append('<ul style="max-height: '+options.maxHeight+'px;" class="dropdown-menu newScroll widDrop" aria-labelledby="dropdownMenu1"></ul>');

    RenderData(options.data,$(options.element).find("ul").first(),"");

  
    //protos inits
    $(options.element).init.prototype.GetParents = function(){
        var jqueryClickedElement = $(options.element).clickedElement;
        return $(jqueryClickedElement).parents("li");
    };

    $(options.element).init.prototype.SetTitle = function(title){
        $(this).find(".dropdowntree-name").text(title);
    };

    $(options.element).init.prototype.GetSelected = function(title){
        var selectedElements = [];
        $(this).find(".fa-check-square-o").each(function(){
            selectedElements.push($(this).parents("li").first());
        });
        return selectedElements;
    };

    $(options.element).init.prototype.AddChildren = function(element, arrOfElements){
        if(options.addChildren && $(element).find("ul").length == 0)
            $(element).append("<ul></ul>");
        element = $(element).find("ul").first();
        if(element.find("li").length==0)
            RenderData(arrOfElements, element,"");
    };

};
})(jQuery);